"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var _1 = require(".");
var element_1 = require("../element");
var __1 = require("..");
var utils_1 = require("../template/utils");
var AreaChart = /** @class */ (function (_super) {
    __extends(AreaChart, _super);
    function AreaChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AreaChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_categories":
                return utils_1.parseJSON(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    AreaChart.prototype.defaultOptions = function () {
        return {
            _order: d3.stackOrderNone,
            _offset: d3.stackOffsetNone,
            _valueFunc: function (d, k) { return d[k]; },
        };
    };
    AreaChart.prototype.init = function () {
        this._xScale = d3.scaleLinear();
        this._yScale = d3.scaleLinear();
        this._groups = this.appendGroupT(_1.Component).data([]).options({});
        this._areas = this._groups.appendT(element_1.Area).options({
            _scaleX: this._xScale,
            _scaleY: this._yScale,
        });
    };
    AreaChart.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        var svgMaxY = this._getGeometry("_height", false);
        var svgMaxX = this._getGeometry("_width", true);
        var stack = d3.stack()
            .value(this.getOption("_valueFunc", null, null, null, true))
            .keys(this.getOption("_categories"))
            .order(this.getOption("_order", null, null, null, true))
            .offset(this.getOption("_offset", null, null, null, true));
        var stackedY = stack(this.datum);
        // Based on the data structure given in the api, the maximum and minimum of all data is given below
        var flattened = _.flatten(stackedY);
        var extent = [d3.min(flattened, function (x) { return x[0]; }), d3.max(flattened, function (x) { return x[1]; })];
        this._groups.data(stackedY);
        this._xScale.domain([0, stackedY[0].length - 1]).nice().range([0, svgMaxX]);
        this._yScale.domain(extent).nice().range([svgMaxY, 0]);
        this.setupProxy({
            yAxis: function (axis) {
                axis.options({
                    _scale: _this._yScale,
                    _gravity: __1.Gravity.Left,
                    _x: 0,
                    _y: 0,
                });
            },
            xAxis: function (axis) {
                axis.options({
                    _scale: _this._xScale,
                    _ticks: stackedY[0].map(function (d, i) { return i; }),
                    _gravity: __1.Gravity.Bottom,
                    _x: 0,
                    _y: svgMaxY,
                });
            },
            area: "_areas",
        });
    };
    return AreaChart;
}(_1.Component));
exports.AreaChart = AreaChart;
//# sourceMappingURL=area-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/area-chart.js
// module id = 1161
// module chunks = 0 1